import { ActionIcon } from "@mantine/core";
import { IconX } from "@tabler/icons-react";
import React, { useEffect, useState } from "react";
import { PaymentEntryRowProps } from "types/interface.types";
import { PaymentGridRow } from "./DataEntryHeaderDefinitions";
/**
 * Note: This component uses intrinsic controls as oppose to mantine <NumberInput> and <Select> becuase of how
 * expensive it is with rendering. This is especially problematic when we have large sets of product entries
 * to input...
 */
/**
 * Note: This component uses intrinsic controls as oppose to mantine <NumberInput> and <Select> becuase of how
 * expensive it is with rendering. This is especially problematic when we have large sets of product entries
 * to input...
 */
const EntryRowComponent: React.FC<PaymentEntryRowProps> = ({
  entry,
  index,
  isLastRow,
  onUpdate,
  onRemove,
  onNewEntry,
}) => {
  const [localInvoiceId, setLocalInvoiceId] = useState(entry.invoiceId);
  const [localAmount, setLocalAmount] = useState<string | null>(
    entry.amount === null ? "" : String(entry.amount),
  );
  const [localOriginalAmount, setLocalOriginalAmount] = useState<string | null>(
    entry.originalAmount === null ? "" : String(entry.originalAmount),
  );
  const [localCoOpFees, setLocalCoOpFees] = useState<string | null>(
    entry.coOpFees === null ? "" : String(entry.coOpFees),
  );

  useEffect(() => {
    setLocalInvoiceId(entry.invoiceId);
  }, [entry.invoiceId]);

  useEffect(() => {
    setLocalAmount(entry.amount === null ? "" : String(entry.amount));
    setLocalOriginalAmount(
      entry.originalAmount === null ? "" : String(entry.originalAmount),
    );
    setLocalCoOpFees(entry.coOpFees === null ? "" : String(entry.coOpFees));
  }, [entry.amount, entry.originalAmount, entry.coOpFees]);

  return (
    <PaymentGridRow>
      <input
        type="number"
        value={localInvoiceId}
        onChange={(e) => {
          const val = Number(e.target.value);
          if (!isNaN(val)) setLocalInvoiceId(val); // local only
        }}
        onBlur={(e) => {
          if (localInvoiceId !== entry.invoiceId) {
            onUpdate({
              ...entry,
              invoiceId: localInvoiceId,
              amount: localAmount === null ? null : Number(localAmount),
              originalAmount:
                localOriginalAmount === null
                  ? null
                  : Number(localOriginalAmount),
              coOpFees: localCoOpFees === null ? null : Number(localCoOpFees),
            }); // commit to parent
          }
        }}
        onFocus={(e) => {
          e.target.select(); // highlight all text on focus
        }}
        className="mantine-input"
        style={{ width: "100%" }}
      />
      <input
        type="text"
        readOnly
        value={entry.debtorName}
        className="mantine-input"
        style={{ width: "100%" }}
      />
      <input
        type="text"
        inputMode="decimal"
        readOnly={Number(localCoOpFees === null ? 0 : localCoOpFees) > 0} // only allow editing if this is a new entry (id is null)
        value={localAmount ?? ""}
        onChange={(e) => {
          const raw = e.target.value;

          // Allow: "", "-", "-1", "1", "1.23", "-1.23"
          const valid = /^-?\d*(\.\d*)?$/.test(raw);

          if (valid) {
            setLocalAmount(raw); // keep as string while typing
          }
        }}
        onBlur={() => {
          if (localAmount !== entry.amount) {
            onUpdate({
              ...entry,
              amount:
                localAmount === "" || localAmount === null
                  ? null
                  : Number(localAmount),
            });
          }
        }}
        className="mantine-input"
        style={{
          width: "100%",
          backgroundColor: `${Number(localCoOpFees === null ? 0 : localCoOpFees) > 0 ? "#f0f0f0" : "inherit"}`, // gray out if co-op fees exist
        }}
      />
      <input
        type="text"
        readOnly
        value={localOriginalAmount === null ? "" : localOriginalAmount}
        className="mantine-input"
        style={{ width: "100%", backgroundColor: "#f0f0f0" }}
      />
      <input
        type="text"
        readOnly
        value={localCoOpFees === null ? "" : localCoOpFees}
        className="mantine-input"
        style={{ width: "100%", backgroundColor: "#f0f0f0" }}
      />
      <ActionIcon
        onClick={onRemove} // only allow delete if not linked to a payment
        onKeyDown={(e) => {
          if (e.key === "Tab" && !e.shiftKey) {
            // only trigger new row if this is the last row
            if (isLastRow) {
              e.preventDefault(); // stop default tabbing
              onNewEntry?.();
            }
          }
        }}
      >
        <IconX size={18} />
      </ActionIcon>
    </PaymentGridRow>
  );
};

// Only re-render if returned or productCode changes
const areEqual = (prev: PaymentEntryRowProps, next: PaymentEntryRowProps) => {
  return (
    prev.entry.invoiceId === next.entry.invoiceId &&
    prev.entry.amount === next.entry.amount &&
    prev.entry.originalAmount === next.entry.originalAmount &&
    prev.entry.effect === next.entry.effect &&
    prev.entry.debtorName === next.entry.debtorName
  );
};

export const PaymentEntryRow = React.memo(EntryRowComponent, areEqual);
